"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_1 = require("react");
var react_final_form_1 = require("react-final-form");
var AccordionInstructions_1 = __importDefault(require("atomicComponents/organisms/Accordion/AccordionInstructions"));
var FieldDropzone_1 = __importDefault(require("components/Form/FieldDropzone"));
var Text_1 = __importDefault(require("shared/components/Text"));
var utils_1 = require("./utils");
var acceptedFileTypes = {
    'application/csv': ['.csv'],
    'text/csv': ['.csv'],
};
var UploadCSV = function (_a) {
    var _b;
    var vendor = _a.vendor, expanded = _a.expanded, rechargeImport = _a.rechargeImport;
    var _c = (0, react_final_form_1.useField)('number').input, invoiceNumber = _c.value, setInvNumber = _c.onChange;
    var csvFile = (0, react_final_form_1.useField)('csvFile').input.value;
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        if (vendor !== 'Xero') {
            return;
        }
        var newInvoiceNumber = (_c = (_b = (_a = csvFile === null || csvFile === void 0 ? void 0 : csvFile[0]) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.match(/[A-Z]{2,}-\d+/)) === null || _c === void 0 ? void 0 : _c[0];
        if (newInvoiceNumber && invoiceNumber !== newInvoiceNumber) {
            setInvNumber(newInvoiceNumber);
        }
    }, [csvFile]);
    return ((0, jsx_runtime_1.jsxs)(AccordionInstructions_1.default, __assign({ expanded: expanded, icon: pro_solid_svg_icons_1.faCircle1, title: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Upload the ", (0, jsx_runtime_1.jsxs)("strong", { children: ["CSV ", vendor !== 'custom' && 'attachment'] }), " ", ((_b = rechargeImport === null || rechargeImport === void 0 ? void 0 : rechargeImport.uploadRequirements) === null || _b === void 0 ? void 0 : _b.fileName)
                    ? "\"".concat(rechargeImport.uploadRequirements.fileName, "\"")
                    : 'with the breakdown by plan'] })) }, { children: [utils_1.EXAMPLE_CSVS[vendor] && (vendor !== 'custom'
                ? (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["View ", (0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "/".concat(utils_1.EXAMPLE_CSVS[vendor]), target: "_blank" }, { children: "example" })) })] }))
                : ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["Download the ", (0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: "/".concat(utils_1.EXAMPLE_CSVS.custom), target: "_blank" }, { children: "template" })) }), ", remove extra rows and fill with custom charges info"] })))), (0, jsx_runtime_1.jsx)(FieldDropzone_1.default, { name: "csvFile", customValidate: function (csvFiles) { return (0, utils_1.validateCsvFile)(vendor, rechargeImport)(csvFiles).then(function (_a) {
                    var error = _a.error;
                    return error;
                }); }, label: "Drop CSV file or browse", maxFiles: 1, accept: acceptedFileTypes, fileIcon: pro_solid_svg_icons_1.faFileCsv })] })));
};
exports.default = UploadCSV;
